import React, { useEffect, useContext } from 'react';

import GlobalContext from 'GlobalContext';

import Tabs from 'components/shared/tabs';
import Card from 'components/new-card/Card';
import BackIcon from 'components/shared/back-arrow-icon';

import AboutView from './tabs/about';
import HtmlTemplateTab from './tabs/html/HtmlTemplateTab';

import './InfobookTemplatesView.scss';

const tabs = [
  {
    key: 0,
    index: 0,
    text: 'About',
    content: <AboutView />,
  },
  {
    key: 1,
    index: 1,
    text: 'HTML',
    content: <HtmlTemplateTab />,
  },
];

const InfobookTemplatesView = () => {
  const { templatesViewTab, setTemplatesViewTab } = useContext(GlobalContext);

  const updateTemplatesTab = (tab) => {
    localStorage.setItem('templatesTab', tab);
    setTemplatesViewTab(tab);
  };

  useEffect(() => {
    const savedTab = localStorage.getItem('templatesTab');

    if (savedTab) {
      setTemplatesViewTab(savedTab);
    }
  }, []);

  return (
    <div className='templates-view'>
      <Card type="static" headerText="Templates" icon={<BackIcon />}>
        <Tabs tabs={tabs} activeTab={templatesViewTab} setActiveTab={updateTemplatesTab} />
      </Card>
    </div>
  );
};

export default InfobookTemplatesView;
